const errorKeys: { [key: string]: string } = {};

export const keyToErrorMessage = (key: string): string => {
  return errorKeys[key] ?? "Ups, coś poszło nie tak";
};
